import { useEffect, useRef, useState } from 'react';
import { DEFAULT_WORKSTREAM_COLOR, WORKSTREAM_COLORS } from '../../pm/constants';

interface Props {
  color?: string;
  onChange: (color: string | null) => void;
}

const WorkstreamColorPicker: React.FC<Props> = ({ color, onChange }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (!wrapRef.current) return;
      if (!wrapRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [open]);

  const current = color || DEFAULT_WORKSTREAM_COLOR;

  function pick(c: string | null) {
    onChange(c);
    setOpen(false);
  }

  return (
    <span className="pm-ws-color-wrap" ref={wrapRef}>
      <button
        type="button"
        className="pm-ws-color-dot"
        style={{ background: current }}
        onClick={() => setOpen((v) => !v)}
        aria-label="Change workstream color"
      />
      {open ? (
        <div className="pm-ws-color-menu">
          <div className="pm-ws-color-grid">
            {WORKSTREAM_COLORS.map((c) => (
              <button
                key={c.value}
                type="button"
                className={`pm-ws-color-swatch ${color === c.value ? 'active' : ''}`}
                style={{ background: c.value }}
                onClick={() => pick(c.value)}
                aria-label={c.label}
                title={c.label}
              />
            ))}
          </div>
          {color ? (
            <button type="button" className="pm-link-button pm-ws-color-clear" onClick={() => pick(null)}>
              Clear color
            </button>
          ) : null}
        </div>
      ) : null}
    </span>
  );
};

export default WorkstreamColorPicker;
